import React from "react";
import styled from "styled-components";
import { LIGHT, BORDER_BLUE } from "../resources/Colors";
import { IMAGES_URL } from "../resources/constants";
import Figure from "./Product/components/Figure";
import { Spinner } from "@etiquette-ui/misc";

const Container = styled.div`
  display: grid;
  grid-template-columns: 40% 1fr;
  height: 9.5rem;
  box-shadow: 1px 2px 6px #ccc;
  border-radius: 0 8px 8px 0;
  text-align: left;
  cursor: default;
  margin-bottom: 15px;
  position: relative;

  @media (min-width: 400px) { 
    grid-template-columns: 9.5rem 1fr;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 9.5rem;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 8px;
  border-radius: 0 8px 8px 0;
  border: ${({ isSelected }) => isSelected ? `2px solid ${BORDER_BLUE}` : `2px solid white`};
  border-left: none;
  position: relative;
  overflow: hidden;
`;

const Image = styled.img`
  width:  100%;
  height: 100%;
  z-index: 1;
  object-fit: cover;
  position: relative;
`;

const ImageContainer = styled(Figure)`
  min-width: 5rem;
  background-position: center;
  z-index: 3;
  width: 100%;
  position: relative;
`;

 const LoaderLayer = styled.div`
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 0;
  width: 100%;
  height: 100%;
  position: absolute;

  display: flex;
  align-items: center;
  justify-content: center;
 `;

const Card = ({ img, is86Inactive, children, handler, isSelected }) => {
  return (
    <Container>
      <ImageWrapper onClick={handler}>
        <ImageContainer is86Inactive={is86Inactive}>
          <LoaderLayer>
            <Spinner
              style={{
                '--color': LIGHT,
                '--bg': 'white',
                "--size": "30px",
                position: 'absolute',
                zIndex: '0',
              }}
            />  
          </LoaderLayer>          
          <Image src={`${IMAGES_URL}/${img ? "mini." + img : "noimage.svg"}`} />
        </ImageContainer>
      </ImageWrapper>
      <Content isSelected={isSelected}>{children}</Content>
    </Container>
  );
};
export default Card;